import { useGeneralStore } from "@/stores/generalStore";
import { useMjmlStore } from "@/stores/mjmlStore";
import { useMergeTagsStore } from "@/stores/mergeTags";
import { usePreviewStore } from "@/stores/preview";
import { useFontStore } from "@/stores/fonts";
import { lockedApi } from "@/api";
import axios from "axios";

export default () => {
  const generalStore = useGeneralStore();
  const mjmlStore = useMjmlStore();
  const mergeTagsStore = useMergeTagsStore();
  const previewStore = usePreviewStore();
  const fontStore = useFontStore();

  function sendTestEmail(recipientEmail: string | string[]) {
    if (generalStore.sentLimitExceeded) {
      return;
    }

    generalStore.sendingTestEmail = true;

    const apiPreviewURL = lockedApi.PREVIEW_SAVE;

    const params = previewStore.params;
    const langToShow = mjmlStore.langToShow || undefined;

    axios
      .post(apiPreviewURL, {
        definition: JSON.stringify(mjmlStore.getMjml()),
        apiKey: mjmlStore.authorize.apiKey,
        hostname: mjmlStore.authorize.hostname,
        userId: mjmlStore.authorize.userId,
        options: {
          minify: generalStore.htmlMinified,
          desktopFirst: generalStore.htmlDesktopFirst,
          fonts: JSON.stringify(fontStore.fontsWithUrl),
          mergeTags: mergeTagsStore.normalizedMergeTagsForPreview,
          evaluateMergeTags: params?.evaluateMergeTags || false,
          emailServiceProvider:
            generalStore.emailServiceProvider || "mailchimp",
          variants: {
            evaluate: params?.variants?.evaluate || false,
            enrichWithConditions:
              params?.variants?.enrichWithConditions || false,
          },
          ...(langToShow ? { language: langToShow } : {}),
          smartMergeTags: mergeTagsStore.smartMergeTagsForRequest,
        },
      })
      .then((data) => {
        const message = {
          type: "callback",
          action: "onTestSend",
          data: {
            args: [recipientEmail, mjmlStore.getMjml(), data.data?.html],
          },
        };

        window.parent.postMessage(JSON.parse(JSON.stringify(message)), "*");

        if (generalStore.type === "topolio") {
          generalStore.sentLimitExceeded = true;
        }
      })
      .finally(() => {
        generalStore.sendingTestEmail = false;
      });
  }

  return {
    sendTestEmail,
  };
};
